import React from 'react';

import { Connect, Provider } from '@rover/react-lib/src/components/utils/Redux';

import GuaranteePage from './GuaranteePage';

const GuaranteePageContainer = (): JSX.Element => {
  return (
    <Provider reducers={{}}>
      <Connect>{(redux) => <GuaranteePage {...redux} />}</Connect>
    </Provider>
  );
};

export default GuaranteePageContainer;
